import React from "react";
import moment from "moment";

import { OverflowTooltip } from "components";
import { Application, TableCellProp } from "types";

const ageOfPendColumn = () => ({
	Header: "Age of Pend",
	accessor: "ageOfPend",
	Cell: ({ row: { original } }: TableCellProp<Application>) => {
		const startDate = original?.pend_started_at;
		const dateTime = moment
			.utc(startDate)
			.local()
			.format("MM/DD/YY h:mm A");
		const duration = moment.utc(startDate).local().fromNow(true);

		return (
			<div>
				<div className="hide-laptop">{dateTime}</div>
				<div className="cut-text-laptop">
					<OverflowTooltip onlyOnLaptop title={duration}>
						{duration}
					</OverflowTooltip>
				</div>
			</div>
		);
	},
});

export default ageOfPendColumn;
